import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ModifierCodesService } from '../../modifier-codes/modifier-codes-service/modifier-codes.service';
import { PrimaryDiagnosisService } from '../../primary-diagnosis/primary-diagnosis-service/primary-diagnosis.service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import { Events } from 'src/app/utils/event-utils';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import * as moment from 'moment-timezone';
import { Observable, forkJoin } from 'rxjs';
import { MemberService } from '../../members/member-service/member.service';
import { DispatchCenterService } from '../../dashboard/dashboard-service/dispatch-center-service';
import { getAddressDetails, nonZeroCoordinateValidator } from 'src/app/utils/utils.common';
@Component({
  selector: 'app-adjustment',
  templateUrl: './adjustment.component.html',
  styleUrls: ['./adjustment.component.css']
})

export class AdjustmentComponent implements OnInit, OnDestroy {
  adjustmentForm: FormGroup;
  zoneFareForm: FormGroup;
  submitted = false;
  tripId;
  todayDate;
  timeZone;
  user;
  fundingSourceList = [];
  preCooperates = {};
  spaceTypeList = [];
  modifierList = [];
  primaryDiagnoseList = [];
  driverList = [];
  fleetList = [];
  selectedDriver;
  isWarning = false;
  tripDetails;
  tripDetailsModalObj;
  filteredAddonsList = [];
  addonsList = [];
  selectedMemberId;
  isFareInformation = false;
  isShowOdometers = false;
  isFromBilling = false;
  isAllowOperations = false;
  addressPickerObj;
  allowToShow = true;
  singleZoneFormSubmitted = false;

  setAllowToShow(value: boolean) {
    this.allowToShow = value;
    const driverControl = this.adjustmentForm.get('driver');
    const fleetControl = this.adjustmentForm.get('fleet');
    if (value) {
      if (driverControl) { driverControl.enable({ emitEvent: false }); }
      if (fleetControl) { fleetControl.enable({ emitEvent: false }); }
    } else {
      if (driverControl) { driverControl.disable({ emitEvent: false }); }
      if (fleetControl) { fleetControl.disable({ emitEvent: false }); }
    }
  }

  constructor(
    private sharedDataService: SharedDataService,
    private activatedRoute: ActivatedRoute,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private modifierCodesService: ModifierCodesService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private driverService: DriversService,
    private fleetService: FleetService,
    private dispatchCenterService: DispatchCenterService,
    private socketService: SocketService,
    private equipmentService: EquipmentService,
    private memberService: MemberService,
    private fb: FormBuilder,
    private assignTripService: AssigTripsService,
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.tripId = params["id"];
      });

    this.activatedRoute.queryParams
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        if (params.isFromBilling) {
          this.isFromBilling = Boolean(params['isFromBilling']);
        }
      });

    this.adjustmentForm = this.fb.group({
      preScheduleTime: [""],
      preAppointmentTime: [""],
      driver: ['', Validators.required],
      odometerBegin: [''],
      odometerStart: [''],
      odometerStop: [''],
      additionalInfoJob: this.fb.group({
        name: [''],
        relation: [''],
        jobTollFee: [''],
        totalMiles: [''],
        additionalWaitTime: [''],
      }),
      refTripId: [''],
      tripId: [''],
      extraId: [''],
      created: [''],
      trackInfoJob: this.fb.group({

        jobAccepted: this.fb.group({
          coords: [[]],
          time: [''],
        }),

        jobArrived: this.fb.group({
          coords: [[]],
          time: [''],
        }),

        jobStarted: this.fb.group({
          coords: [[]],
          time: [''],
        }),

        jobCompleted: this.fb.group({
          coords: [[]],
          time: [''],

        }),

        jobFinished: this.fb.group({
          coords: [[]],
          time: [''],
        }),

        jobCancelled: this.fb.group({
          coords: [[]],
          time: [''],
        }),
      }),
      ipa: ['',],
      scheduleTime: [''],
      appointmentTime: [''],
      milage: ['0'],
      cooperate: ['', Validators.required],
      spaceType: ['', Validators.required],
      fleet: ['', Validators.required],
      job: [''],
      preSpecialRate: [''],

      primaryDiagnosis: [''],
      primaryDiagnosisId: [''],

      puModifier: [''],
      puModifierId: [''],

      doModifier: [''],
      doModifierId: [''],
      companyNote: [''],


      addonServices: this.fb.array([]),
      priorityClient: this.fb.group({

        tpDisplayName: [{ value: "", disabled: true }, Validators.required],
        displayName: ["", Validators.required],

        tpContactNumber: [{ value: "", disabled: true }, Validators.required],
        contactNumber: ["", Validators.required],

        tpCellPhone: [{ value: "", disabled: true }],
        cellPhone: [""],

        tpClientId: [{ value: "", disabled: true }],
        clientId: [""],

        email: [""],
        // memberId: [""],
        tpDob: [{ value: "", disabled: true }],
        dob: [""],

        tpGender: [{ value: "", disabled: true }],
        gender: [""],

        homeAddress: this.fb.group({
          tpAddress: [{ value: "", disabled: true }],
          address: [""],
          street: [""],
          aptOrSuite: [""],
          city: [""],
          state: [""],
          zipCode: [""]
        })
      }),
      baseFare: [0],
      perMile: [0],
      // cancelCharges: [0],
      noShowCharges: [0],
      // code: [""],
      perMileCode: [""],
      dryRunCode: [""],
      baseFareCode: [""],
      authorizationNumber: [""],
      client: [''],
      status: [''],
      jobOriginAddress: ['', Validators.required],
      jobOriginLatitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobOriginLongitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationLongitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      zones: this.fb.array([]),
      baseFareFor :['0',Validators.required],
      isPerMileZone: [false],
    });


    this.adjustmentForm.controls['cooperate'].valueChanges.subscribe(value => {
      if (value) {
        const checkFundingSource = this.fundingSourceList.find(item => item._id === value);
        const keys = [
        "tripId",
          "milage",
          "preSpecialRate",
          "primaryDiagnosis",
          "primaryDiagnosisId",
          "puModifier",
          "puModifierId",
          "doModifier",
          "doModifierId",
          "baseFare",
          "perMile",
          "authorizationNumber"
        ];
        
         if (this.tripDetails && this.tripDetails.status !== 'cancelled' && this.tripDetails.job ) {
          keys.push("perMileCode");
          keys.push("baseFareCode");
        }

        const keysTwo = [
          "clientId",
          "dob",
          "gender"
        ];

        const keysThree = [
          "address",
          "street",
          "state",
          "zipCode"
        ];

        if (checkFundingSource && checkFundingSource.requireForm837 ) {
          this.setValidations(keys, true);
          this.setValidations(keysTwo, true, 'priorityClient');
          this.setValidations(keysThree, true, 'priorityClient', 'homeAddress');
        } else {
          this.setValidations(keys, false);
          this.setValidations(keysTwo, false, 'priorityClient');
          this.setValidations(keysThree, false, 'priorityClient', 'homeAddress');
        }
      }

    });

    
    this.zoneFareForm = this.fb.group({
      fare: ['', Validators.required],
      from: ['', Validators.required],
      to: ['', Validators.required]
    });


    this.getUser();
  }

    calculateTotalFare() {
    if (this.adjustmentForm.value.status === 'cancelled') {
      return;
    }

    const payload = {
      milage: this.adjustmentForm.value.milage,
      jobOriginLatitude: this.adjustmentForm.value.jobOriginLatitude,
      jobOriginLongitude: this.adjustmentForm.value.jobOriginLongitude,
      jobDestinationLatitude: this.adjustmentForm.value.jobDestinationLatitude,
      jobDestinationLongitude: this.adjustmentForm.value.jobDestinationLongitude,
      scheduleTime: this.adjustmentForm.value.scheduleTime,
      addonServices: this.adjustmentForm.value.addonServices,
      jobFareFormula: {
        baseFare: {
          fare: this.adjustmentForm.value.baseFare,
          for: this.adjustmentForm.value.baseFareFor
        },
        perMile: this.adjustmentForm.value.perMile,
        zones: this.adjustmentForm.value.zones,
        noShowCharges: this.adjustmentForm.value.noShowCharges,
        isPerMileZone: this.adjustmentForm.value.isPerMileZone


      }
    };

    this.dispatchCenterService.saveAdjustedFare(payload).subscribe(data=>{
      if(data){
        this.adjustmentForm.patchValue({
          preSpecialRate: data.totalFare,

        });
      }
    })


  }

  getRequiredFields(controls) {
    const requiredFields = [];
    for (const name in controls) {
      const control = controls[name];
      if (control.errors && control.errors['required']) {
        requiredFields.push(name);
      }
    }
    return requiredFields;
  }


  setValidations(keys, isSet, formName?, formName2?) {
    for (let key of keys) {
      let form = this.adjustmentForm.get(key);

      if (formName) {
        if (formName2) {
          form = this.adjustmentForm.get(formName).get(formName2).get(key);
        } else {
          form = this.adjustmentForm.get(formName).get(key);
        }
      }

      if (isSet) {
        if (key === 'primaryDiagnosis') {
          form.setValidators([Validators.required, this.noWhitespaceValidator]);
        } else {
          form.setValidators([Validators.required]);
        }
      } else {
        form.clearValidators();
      }

      form.updateValueAndValidity();
    }
  }

  noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }





  listenSocket() {
    this.socketService.addListener(Events.GET_TRIP_DISTANCE)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
        }
      });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment().tz(this.timeZone);

          this.adjustmentForm.patchValue({
            preScheduleTime: this.todayDate,
            scheduleTime: this.todayDate.toISOString(),

            preAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            appointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
          });

          this.makeCompulsoryCalls();
          this.getSpaceTypeList();
          this.getDriverList();
          this.getFleetList();
        }
      });
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getPrimaryDiagnoseList(),
      this.getModifierList(),
      this.getFundingSourceList()
    ];

    forkJoin(requests).subscribe(
      ([res1, res2, res3]) => {

        if (res1) {
          this.primaryDiagnoseList = res1;
        }

        if (res2) {
          this.modifierList = res2;
        }

        if (res3) {
          this.fundingSourceList = res3;
          this.preCooperates = res3;
        }

        this.getCompletedTripDetail();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }


  getCompletedTripDetail() {
    this.dispatchCenterService.getTripDetail(this.tripId, this.isFromBilling).subscribe(async data => {
      if (data) {
        let selectedFundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === data.cooperate);
        if (selectedFundingSource) {
          if (selectedFundingSource.hasOwnProperty('requireForm837')) {
            this.isFareInformation = selectedFundingSource.requireForm837;
          }
          this.isShowOdometers = selectedFundingSource.requiredOdometers === 0 ? false : true;
        }

        this.tripDetails = data;
        this.adjustmentForm.patchValue({
          ...data,
          refTripId: this.isFromBilling ? data.refTripId : data.tripId,
          preScheduleTime: moment(data.scheduleTime).tz(this.timeZone),
          preAppointmentTime: moment(data.appointmentTime).tz(this.timeZone),
          preRecurringEndDate: data.recurringEndDate ? moment(data.recurringEndDate).tz(this.timeZone) : null,
          driver: this.isFromBilling ? data.driver : data.driver._id,
          trackInfoJob: this.isFromBilling ? data.trackInfoJob : data.job.trackInfoJob,
          job: this.isFromBilling ? data.job : data.job._id,
          // created: data.job.created,
          // add additional
          companyNote: data.companyNote ? data.companyNote : '',
          primaryDiagnosis: data.primaryDiagnosis ? data.primaryDiagnosis : '',
          primaryDiagnosisId: this.isFromBilling ? (data.primaryDiagnosisId ? data.primaryDiagnosisId :''): await this.getPrimaryDiagnosisId(data.primaryDiagnosis),

          puModifier: data.originAddressAdditional && data.originAddressAdditional.modifier ? data.originAddressAdditional.modifier : '',
          puModifierId: this.isFromBilling ?  (data.puModifierId ? data.puModifierId :'') : (data.originAddressAdditional ? await this.getModifierId(data.originAddressAdditional.modifier) : ""),

          doModifier: data.destinationAddressAdditional && data.destinationAddressAdditional.modifier ? data.destinationAddressAdditional.modifier : '',
          doModifierId: this.isFromBilling ?  (data.doModifierId ? data.doModifierId :'')  : (data.destinationAddressAdditional ? await this.getModifierId(data.destinationAddressAdditional.modifier) : ""),

          created: this.getCreatedTime(this.isFromBilling ? data.trackInfoJob : data.job.trackInfoJob),
          additionalInfoJob: this.isFromBilling ? data.additionalInfoJob : data.job.additionalInfoJob,

        });



        this.adjustmentForm.patchValue({
          priorityClient: {
            tpDisplayName: data.priorityClient.displayName,
            tpContactNumber: data.priorityClient.contactNumber,
            tpCellPhone: data.priorityClient.cellPhone,
            tpClientId: data.priorityClient.clientId,
            tpDob: data.priorityClient.dob
          }
        });

        if (data.job.odometerBegin || data.odometerBegin) {
          this.adjustmentForm.patchValue({
            odometerBegin: this.isFromBilling ? data.odometerBegin : data.job.odometerBegin,
            odometerStart: this.isFromBilling ? data.odometerStart : data.job.odometerStart,
            odometerStop: this.isFromBilling ? data.odometerStop : data.job.odometerStop
          });
        }


        if (data.cooperate) {
          this.getAddonsList(data.cooperate);
        }

        if (data.addonServices) {
          this.addAddonsItem(data.addonServices)
        }

        if (data.zones) {
          this.addPreZoneItem(data.zones)
        }
        
        if (data.client) {
          this.getMember(data.client)
        }

        if (this.tripDetails && this.tripDetails.cooperate && this.preCooperates && this.preCooperates[this.tripDetails.cooperate]) {
          if (this.preCooperates[this.tripDetails.cooperate].companyType === "callthecar"&& this.user.isCtcDriverVehicleLocked) {
            this.setAllowToShow(false);
          } else {
            this.setAllowToShow(true);
          }
        } else {
          this.setAllowToShow(true);
        }

      }
      this.isAllowOperations = true;
    })
    this.getFareDetails();
  }

  getFundingSourceList() {
    return this.corporateService
      .getCorporateUsers('active')

  }

  getFareDetails() {
    this.dispatchCenterService.getFareDetail(this.tripId).pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.adjustmentForm.patchValue({
            ...data,
            baseFare: data.baseFare.fare,
            baseFareFor : data.baseFare.for,
          })
        }
      })
  }

  getSpaceTypeList() {
    this.levelOfServiceService.getSpaceTypes({ status: 'active' }).pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });;
  }

  getModifierList() {
    return this.modifierCodesService
      .getModifierCodes();
  }

  getPrimaryDiagnoseList() {
    return this.primaryDiagnosisService
      .getPrimaryDiagnosis();
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.fleetList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }


  setPickTimeChange(event, index?) {
    this.adjustmentForm.patchValue({
      scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
    });
  }

  setDropOffTimeChange(event, index?) {
    this.adjustmentForm.patchValue({
      appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
    });

  }

  onCreatedTimeChange() {
    if (this.adjustmentForm.value.created.time._d) {
      this.adjustmentForm.controls.created.patchValue({
        time: this.adjustmentForm.value.created.toISOString()
      });
    }
  }

  onAcceptedTimeChange() {
    if (this.adjustmentForm.value.trackInfoJob.jobAccepted.time._d) {
      this.adjustmentForm.controls.trackInfoJob['controls'].jobAccepted.patchValue({
        time: this.adjustmentForm.value.trackInfoJob.jobAccepted.time.toISOString()
      });
    }
  }

  onArrivedTimeChange() {
    if (this.adjustmentForm.value.trackInfoJob.jobArrived.time._d) {
      this.adjustmentForm.controls.trackInfoJob['controls'].jobArrived.patchValue({
        time: this.adjustmentForm.value.trackInfoJob.jobArrived.time.toISOString()
      });
    }
  }

  onStartedTimeChange() {
    if (this.adjustmentForm.value.trackInfoJob.jobStarted.time._d) {
      this.adjustmentForm.controls.trackInfoJob['controls'].jobStarted.patchValue({
        time: this.adjustmentForm.value.trackInfoJob.jobStarted.time.toISOString()
      });
    }
  }

 async onCompletedTimeChange() {
    if (this.adjustmentForm.value.trackInfoJob.jobCompleted.time._d) {
      this.adjustmentForm.controls.trackInfoJob['controls'].jobCompleted.patchValue({
        time: this.adjustmentForm.value.trackInfoJob.jobCompleted.time.toISOString()
      });

      const finishedTime = this.adjustmentForm.value.trackInfoJob.jobCompleted.time;

      const routingDistance: any = await this.assignTripService.getRoutingDistance(this.tripDetails.jobOriginLatitude, this.tripDetails.jobOriginLongitude, this.tripDetails.jobDestinationLatitude, this.tripDetails.jobDestinationLongitude).toPromise();
      const segments: any = routingDistance.features[0].properties.segments;

      this.adjustmentForm.controls.trackInfoJob['controls'].jobStarted.patchValue({
        // tslint:disable-next-line: max-line-length
        time: moment(this.adjustmentForm.value.trackInfoJob.jobCompleted.time).subtract((segments[0].duration / 60), 'minutes').toISOString()
      });


      this.adjustmentForm.controls.trackInfoJob['controls'].jobArrived.patchValue({
        time: moment(this.adjustmentForm.value.trackInfoJob.jobStarted.time).subtract(5, 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobAccepted.patchValue({
        time: moment(this.adjustmentForm.value.trackInfoJob.jobArrived.time).subtract(5, 'minutes').toISOString()
      });

      this.adjustmentForm.patchValue({
        created: moment(this.adjustmentForm.value.trackInfoJob.jobAccepted.time).toISOString()
      });



      this.adjustmentForm.controls.trackInfoJob['controls'].jobFinished.patchValue({
        // tslint:disable-next-line: max-line-length
        time: moment(finishedTime).add(2, 'minutes').toISOString()
      });
    }
  }

  async onFinishedTimeChange() {
    if (this.adjustmentForm.value.trackInfoJob.jobFinished.time._d) {
      this.adjustmentForm.controls.trackInfoJob['controls'].jobFinished.patchValue({
        time: this.adjustmentForm.value.trackInfoJob.jobFinished.time.toISOString()
      });

      const routingDistance: any = await this.assignTripService.getRoutingDistance(this.tripDetails.jobOriginLatitude, this.tripDetails.jobOriginLongitude, this.tripDetails.jobDestinationLatitude, this.tripDetails.jobDestinationLongitude).toPromise();
      const segments: any = routingDistance.features[0].properties.segments;

      this.adjustmentForm.controls.trackInfoJob['controls'].jobCompleted.patchValue({
        // tslint:disable-next-line: max-line-length
        time: moment(this.adjustmentForm.value.trackInfoJob.jobFinished.time).subtract(2, 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobStarted.patchValue({
        // tslint:disable-next-line: max-line-length
        time: moment(this.adjustmentForm.value.trackInfoJob.jobCompleted.time).subtract((segments[0].duration / 60), 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobArrived.patchValue({
        time: moment(this.adjustmentForm.value.trackInfoJob.jobStarted.time).subtract(5, 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobAccepted.patchValue({
        time: moment(this.adjustmentForm.value.trackInfoJob.jobArrived.time).subtract(5, 'minutes').toISOString()
      });

      this.adjustmentForm.patchValue({
        created: moment(this.adjustmentForm.value.trackInfoJob.jobAccepted.time).toISOString()
      });

    }
  }

 async onCancelledTimeChange() {
    if (this.adjustmentForm.value.trackInfoJob.jobCancelled.time._d) {
      this.adjustmentForm.controls.trackInfoJob['controls'].jobCancelled.patchValue({
        time: this.adjustmentForm.value.trackInfoJob.jobCancelled.time.toISOString()
      });

      const routingDistance: any = await this.assignTripService.getRoutingDistance(this.tripDetails.jobOriginLatitude, this.tripDetails.jobOriginLongitude, this.tripDetails.jobDestinationLatitude, this.tripDetails.jobDestinationLongitude).toPromise();
      const segments: any = routingDistance.features[0].properties.segments;


      this.adjustmentForm.controls.trackInfoJob['controls'].jobFinished.patchValue({
        // tslint:disable-next-line: max-line-length
        time: moment(this.adjustmentForm.value.trackInfoJob.jobCancelled.time).subtract(2, 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobCompleted.patchValue({
        // tslint:disable-next-line: max-line-length
        time: moment(this.adjustmentForm.value.trackInfoJob.jobFinished.time).subtract(2, 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobStarted.patchValue({
        // tslint:disable-next-line: max-line-length
        time: moment(this.adjustmentForm.value.trackInfoJob.jobCompleted.time).subtract((segments[0].duration / 60), 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobArrived.patchValue({
        time: moment(this.adjustmentForm.value.trackInfoJob.jobStarted.time).subtract(5, 'minutes').toISOString()
      });

      this.adjustmentForm.controls.trackInfoJob['controls'].jobAccepted.patchValue({
        time: moment(this.adjustmentForm.value.trackInfoJob.jobArrived.time).subtract(5, 'minutes').toISOString()
      });

      this.adjustmentForm.patchValue({
        created: moment(this.adjustmentForm.value.trackInfoJob.jobAccepted.time).toISOString()
      });


    }
  }


  onSelectFundingSource(corporateId) {
    this.clearAddons();
    this.isFareInformation = false;
    const fundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === corporateId);
    if (fundingSource) {
      this.getAddonsList(fundingSource._id);
      if (fundingSource.hasOwnProperty('requireForm837')) {
        this.isFareInformation = fundingSource.requireForm837
      }
      this.isShowOdometers = fundingSource.requiredOdometers === 0 ? false : true;

      if (fundingSource.companyType === "callthecar"&& this.user.isCtcDriverVehicleLocked) {
        this.setAllowToShow(false);
        this.adjustmentForm.patchValue({
          driver: this.isFromBilling ? this.tripDetails.driver : this.tripDetails.driver._id,
          fleet: this.tripDetails.fleet
        })
      } else {
        this.setAllowToShow(true);
      }

    }
  }

  onSelectDriver(evt) {
    this.selectedDriver = evt;
  }

  onAdjustment() {

    this.submitted = true;
    if (this.adjustmentForm.invalid) {
      return;
    }

    let payload = this.adjustmentForm.getRawValue();

    payload = {
      ...this.tripDetails,
      ...payload
    };

    if (!payload.primaryDiagnosisId) {
      payload.primaryDiagnosis = '';
      payload.primaryDiagnosisId = null;
    }

    if (!payload.puModifierId) {
      payload.puModifier = '';
      payload.puModifierId = null;
    }

    if (!payload.doModifierId) {
      payload.doModifier = '';
      payload.doModifierId = null;
    }


    if (payload._id) {
      delete payload._id;
    }

    this.dispatchCenterService
      .saveTripAdjustment(this.isFromBilling ? this.tripId : payload.job, payload, this.isFromBilling)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          sweetAlert('Success', 'Updated Successfully!', 'success', 'OK');
        } else {
          sweetAlert('Error', "Something went wrong!", 'warning', 'OK');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  checkWarning() {
    this.isWarning = !this.isWarning;
  }

  viewTripDetails(tripDetail) {
    if (tripDetail) {
      this.tripDetailsModalObj = tripDetail

    }
  }

  onSelectSpaceType(spaceTypeId) {
    this.clearAddons();
    this.filteredAddonsList = this.addonsList.filter(addon => addon.spaceType === spaceTypeId);
  }

  getAddonsList(fundingSourceId) {
    let queryParams = {
      isAddon: true,
      cooperate: fundingSourceId
    }
    this.equipmentService
      .getEquipments(queryParams)
      .subscribe(data => {
        if (data) {
          this.addonsList = data;
          this.filteredAddonsList = this.addonsList.filter(addon => addon.spaceType === this.adjustmentForm.value.spaceType);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  addAddonsItem(preAddonList?) {
    const items = this.adjustmentForm.get('addonServices') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addonId: [addon.addonId, Validators.required],
            quantity: [addon.quantity, [Validators.required, Validators.min(1)]],
            title: [addon.title],
            code: [addon.code],
            fare: [addon.fare],
            total: [addon.total]
          })
        );
      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addonId: ['', Validators.required],
        quantity: [1, [Validators.required, Validators.min(1)]],
        title: [''],
        code: [""],
        fare: [0],
        total: [0]
      })
    );
    // }
  }

    addPreZoneItem(preList) {
    const items = this.adjustmentForm.get('zones') as FormArray;

    if (preList) {
      for (const zone of preList) {
        items.push(
          this.fb.group(zone)
        );
      }
    }
    }
  
  removeAddonsItem(index: any) {
    const items = this.adjustmentForm.get('addonServices') as FormArray;
    items.removeAt(index);
    this.calculateTotalFare();
  }

  onSelectAddonItem(addonItem) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find(item => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
    this.calculateTotalFare();
  }

  clearAddons() {
    const addonServices = this.adjustmentForm.get('addonServices') as FormArray;
    addonServices.clear();
  }

  editMember() {
    this.selectedMemberId = this.tripDetails.client;
  }

  onSaveMember(evt) {
    if (evt) {
      this.adjustmentForm.patchValue({
        priorityClient: {
          ...evt,
          tpDisplayName: evt.displayName,
          tpContactNumber: evt.contactNumber,
          tpCellPhone: evt.cellPhone,
          tpClientId: evt.clientId,
          tpDob: evt.dob,
          tpGender: evt.gender,
          homeAddress: {
            ...evt.homeAddress,
            tpAddress: evt.homeAddress.address
          }
        }

      });
      this.selectedMemberId = null;
    }
  }

  getMember(memberId) {
    this.memberService
      .getMemberById(memberId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.onSaveMember(data)
        }
      });
  }

  get addonsForm() {
    return this.adjustmentForm.get('addonServices') as FormArray;
  }

  get form() {
    return this.adjustmentForm.controls;
  }

  get zoneForm() {
    return this.zoneFareForm.controls;
  }

  onChangePuModifier(evt) {
    let puModifier = '';
    if (evt) {
      const modifierItem = this.modifierList.find(item => item._id === evt);
      if (modifierItem)
        puModifier = `${modifierItem.code} - ${modifierItem.title}`;;
    }

    this.adjustmentForm.patchValue({
      puModifier
    })
  }

  onChangeDoModifier(evt) {
    let doModifier = '';
    if (evt) {
      const modifierItem = this.modifierList.find(item => item._id === evt)
      if (modifierItem)
        doModifier = `${modifierItem.code} - ${modifierItem.title}`;
    }
    this.adjustmentForm.patchValue({
      doModifier
    })
  }

  onChangePrimaryDiagnosis(evt) {
    let primaryDiagnosis = '';
    if (evt) {
      const primaryDiagnose = this.primaryDiagnoseList.find(item => item._id === evt)
      if (primaryDiagnose)
        primaryDiagnosis = `${primaryDiagnose.code} - ${primaryDiagnose.title}`;
    }

    this.adjustmentForm.patchValue({
      primaryDiagnosis
    })

  }

  getCreatedTime(trackInfoJob) {
    return trackInfoJob && trackInfoJob.jobAccepted && trackInfoJob.jobAccepted.time ? trackInfoJob.jobAccepted.time : ''
  }

  async getPrimaryDiagnosisId(primaryDiagnosis) {
    let selectedPrimaryDiagnosis;
    if (primaryDiagnosis && primaryDiagnosis.split(" - ")) {
      const code = primaryDiagnosis.split(" - ")[0];
      selectedPrimaryDiagnosis = await this.primaryDiagnoseList.find(p => code === p.code);
    }
    return selectedPrimaryDiagnosis ? selectedPrimaryDiagnosis._id : ""
  }

  async getModifierId(modifier) {
    let selectedModifier;
    if (modifier && modifier.split(" - ")) {
      const code = modifier.split(" - ")[0];
      selectedModifier = await this.modifierList.find(p => code === p.code);
    }
    return selectedModifier ? selectedModifier._id : ""
  }

  setOriginAddress(place) {
    this.adjustmentForm.patchValue({
      jobOriginAddress: place.formatted_address,
      jobOriginLatitude: place.geometry.location.lat(),
      jobOriginLongitude: place.geometry.location.lng(),
    });
  }

  setDestinationAddress(place) {
    this.adjustmentForm.patchValue({
      jobDestinationAddress: place.formatted_address,
      jobDestinationLatitude: place.geometry.location.lat(),
      jobDestinationLongitude: place.geometry.location.lng(),
    });
  }

  loadAddressPicker(title, value, address?, lat?, lng?, zipCode?) {
    this.addressPickerObj = { title, value, address, lat, lng, zipCode };
  }

  onAddressPicker(event) {
    if(event){
        this.adjustmentForm.patchValue({
          trackInfoJob: {
            [event.reference.title]: {
              coords: [event.lng, event.lat],
            }
          }
        });
    }
    this.addressPickerObj = null;
  }

  
  addZone() {
    this.singleZoneFormSubmitted = true;
    if (this.zoneFareForm.invalid) {
      return;
    }

    (this.adjustmentForm.get('zones') as FormArray).push(this.fb.group(this.zoneFareForm.value));
    this.zoneFareForm.reset();
    this.singleZoneFormSubmitted = false;
    this.calculateTotalFare();

  }

  removeZone(index) {
    const items = this.adjustmentForm.get('zones') as FormArray;
    items.removeAt(index);
    this.calculateTotalFare();
  }

  toggleZonePerMile() {
    this.adjustmentForm.patchValue({
      isPerMileZone: !this.adjustmentForm.value.isPerMileZone
    });
    if (this.adjustmentForm.value.zones && this.adjustmentForm.value.zones.length) {
      this.calculateTotalFare();
    }
  }


  onChangeNoShow() {
    this.adjustmentForm.patchValue({
      preSpecialRate: this.adjustmentForm.value.noShowCharges,
    })
  }

 onChangeStatus() {
    if (this.adjustmentForm.value.status === 'cancelled') {
      this.onChangeNoShow();
    }else{
      this.calculateTotalFare();
    }

 }

  ngOnDestroy(): void {
  }

}

